import {Component, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgbAlert, NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {ApiService} from "@ctms/api.service";
import {Page} from "@ctms/api/api.interfaces";
import {ChartOptions} from "@shared/chart/chart-options";
import {NgApexchartsModule} from "ng-apexcharts";
import {BreadcrumbService} from "@cdss/services/breadcrumb.service";
import {DemoPatientOverviewRecordsTabComponent} from "./tabs/records/patient-overview.records-tab.component";
import {
    CreateTherapeuticScheduleComponent
} from "../../cdss/therapeutic-schedule/create/create-therapeutic-schedule.component";

@Component({
    selector: 'demo-patient-overview',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, NgbNavModule, NgbAlert, NgApexchartsModule, DemoPatientOverviewRecordsTabComponent, CreateTherapeuticScheduleComponent],
    providers: [ApiService],
    templateUrl: './patient-overview.component.html',
    styleUrl: './patient-overview.component.scss'
})
export class DemoPatientOverviewComponent {
    errorMessage!: string;
    loading = false;

    @ViewChild("table") table: any;

    page: Page = {
        size: 10,
        start: 0,
        totalCount: 0
    };
    offset: number = 0
    latestDailySnapshotRows = [
        {
            reported: "Patient reported",
            exercise: 60,
            purgingBehaviour: 2,
            useOfLaxatives: 5,
            useOfDiuretics: 0,
            bingeEpisodes: 0,
            skippedMeals: 4,
            lifeEvents: 0,
        },
        {
            reported: "Carer reported",
            exercise: 60,
            purgingBehaviour: 2,
            useOfLaxatives: 5,
            useOfDiuretics: 0,
            bingeEpisodes: 0,
            skippedMeals: 4,
            lifeEvents: 0,
        },
    ]
    latestRoutineRows1 = [
        {
            reported: "Patient reported",
            exercise: 60,
            purgingBehaviour: 2,
            useOfLaxatives: 5,
            useOfDiuretics: 0,
            bingeEpisodes: 0,
            skippedMeals: 4,
            lifeEvents: 0,
        },
    ]
    latestRoutineRows2 = [
        {
            reported: "Patient reported",
            exercise: 60,
            purgingBehaviour: 2,
            useOfLaxatives: 5,
            useOfDiuretics: 0,
            bingeEpisodes: 0,
            skippedMeals: 4,
            lifeEvents: 0,
        },
    ]

    sortField: string = 'participantCode'
    order: string = 'asc'

    filterForm: FormGroup
    activeTab: number = 1;

    weightChartOptions: Partial<ChartOptions>;
    ed15ChartOptions: Partial<ChartOptions>;

    constructor(
        public toastr: ToastrService,
        private breadcrumbService: BreadcrumbService,
    ) {
    }

    ngOnInit() {
        this.weightChartOptions = this.initChart("")
        this.ed15ChartOptions = this.initChart("")
        this.refreshCharts()
        this.breadcrumbService.set([
            {title: "Patients", url: "demo/patient-list"},
            {title: "Jane Smith", url: null},
        ])
    }

    refreshCharts() {
        this.weightChartOptions.series = [
            {
                name: "Weight",
                data: [45, 42, 39, 37, 41, 42]
            }
        ]
        this.weightChartOptions.xaxis.categories = ["2/6/2025", "3/6/2025", "4/6/2025", "5/6/2025", "6/6/2025", "7/6/2025"];
        this.weightChartOptions.yaxis = this.weightChartOptions.yaxis || {};
        this.weightChartOptions.yaxis.labels = this.weightChartOptions.yaxis.labels || {};
        this.weightChartOptions.yaxis.min = 0
        this.weightChartOptions.yaxis.max = 50
        this.weightChartOptions.yaxis.labels.formatter = (value) => {
            return value + " Kg"
        }

        this.ed15ChartOptions.series = [
            {
                name: "Weight/Shape concerns",
                data: [30, 75, 91, 80, 85]
            },
            {
                name: "Eating concerns",
                data: [28, 50, 70, 65, 67]
            },
        ]
        this.ed15ChartOptions.xaxis.categories = ["2/6/2025", "9/6/2025", "16/6/2025", "23/6/2025", "30/6/2025"];
        this.ed15ChartOptions.yaxis = this.ed15ChartOptions.yaxis || {};
        this.ed15ChartOptions.yaxis.labels = this.ed15ChartOptions.yaxis.labels || {};
        this.ed15ChartOptions.yaxis.min = 0
        this.ed15ChartOptions.yaxis.max = 100

    }

    initChart(title: string): Partial<ChartOptions> {
        return {
            series: [],
            chart: {
                height: 350,
                type: "line",
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: "smooth"
            },
            title: {
                text: title,
                align: "left"
            },
            grid: {
                row: {
                    colors: ["#f3f3f3", "transparent"],
                    opacity: 0.5
                }
            },
            xaxis: {
                categories: []
            },

        };
    }


    reset(): void {

    }

    filter(): void {

    }

    setPage(pageInfo) {
        this.loading = true
        this.page.start = pageInfo.offset * this.page.size
        this.refreshRows()
    }

    sort(pageInfo) {
        this.loading = true
        this.sortField = pageInfo.sorts[0].prop
        this.order = pageInfo.sorts[0].dir
        this.table.offset = this.page.start
        this.refreshRows()
    }

    refreshRows() {

    }
}
